import {
  CALENDAR_EVENT_TYPE,
  NOTIFICATION_TYPE,
} from '@esentai/core/features/campaigns/consts/types';

export const TYPES_WITHOUT_START_DATE = [NOTIFICATION_TYPE];

export const TYPES_WITHOUT_END_DATE = [CALENDAR_EVENT_TYPE, NOTIFICATION_TYPE];
